var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasData
    ? _c(
        "v-card",
        { staticClass: "my-2", attrs: { flat: "" } },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c("v-card-title", { staticClass: "py-3 info-block-title" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "ecdgray--text subtitle-2 text-uppercase subtitle-3"
                  },
                  [_vm._v(_vm._s(_vm.$t("DealDetails")))]
                )
              ]),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "info-container body-1 black--text" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "info-block",
                          attrs: { cols: "12", md: "4" }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "caption ecgray--text text--darken-2"
                            },
                            [_vm._v(_vm._s(_vm.$t("DealDescription")))]
                          ),
                          _c("v-text-field", {
                            model: {
                              value:
                                _vm.invoicingDealDetailsModel.dealDescription,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.invoicingDealDetailsModel,
                                  "dealDescription",
                                  $$v
                                )
                              },
                              expression:
                                "invoicingDealDetailsModel.dealDescription"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "info-block",
                          attrs: { cols: "12", md: "4" }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "caption ecgray--text text--darken-2"
                            },
                            [_vm._v(_vm._s(_vm.$t("CustomerName")))]
                          ),
                          _c("v-text-field", {
                            attrs: { rules: [_vm.vr.primitives.required] },
                            model: {
                              value: _vm.invoicingDealDetailsModel.consumerName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.invoicingDealDetailsModel,
                                  "consumerName",
                                  $$v
                                )
                              },
                              expression:
                                "invoicingDealDetailsModel.consumerName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "info-block",
                          attrs: { cols: "12", md: "4" }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "caption ecgray--text text--darken-2"
                            },
                            [_vm._v(_vm._s(_vm.$t("NationalID")))]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.vr.special.israeliNationalId]
                            },
                            model: {
                              value:
                                _vm.invoicingDealDetailsModel
                                  .consumerNationalID,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.invoicingDealDetailsModel,
                                  "consumerNationalID",
                                  $$v
                                )
                              },
                              expression:
                                "invoicingDealDetailsModel.consumerNationalID"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.editable
                        ? [
                            _vm.invoicingDealDetailsModel.consumerID
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "info-block",
                                    attrs: { cols: "12", md: "4" }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "caption ecgray--text text--darken-2"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Customer")))]
                                    ),
                                    _vm.consumerName
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.invoicingDealDetailsModel
                                                  .consumerName
                                              ) +
                                              " "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("guid")(
                                                  _vm.invoicingDealDetails
                                                    .consumerID
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c(
                              "v-col",
                              {
                                staticClass: "info-block",
                                attrs: { cols: "12", md: "4" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "caption ecgray--text text--darken-2"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CustomerEmail")))]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    rules: [
                                      _vm.vr.primitives.required,
                                      _vm.vr.primitives.email
                                    ]
                                  },
                                  model: {
                                    value:
                                      _vm.invoicingDealDetailsModel
                                        .consumerEmail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.invoicingDealDetailsModel,
                                        "consumerEmail",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "invoicingDealDetailsModel.consumerEmail"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "info-block",
                                attrs: { cols: "12", md: "4" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "caption ecgray--text text--darken-2"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("CustomerPhone")))]
                                ),
                                _c("v-text-field", {
                                  model: {
                                    value:
                                      _vm.invoicingDealDetailsModel
                                        .consumerPhone,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.invoicingDealDetailsModel,
                                        "consumerPhone",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "invoicingDealDetailsModel.consumerPhone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.invoicingDealDetailsModel
                              .consumerExternalReference
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "info-block",
                                    attrs: { cols: "12", md: "4" }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "caption ecgray--text text--darken-2"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CustomerExternalReference")
                                          )
                                        )
                                      ]
                                    ),
                                    _c("v-text-field", {
                                      model: {
                                        value:
                                          _vm.invoicingDealDetailsModel
                                            .consumerExternalReference,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.invoicingDealDetailsModel,
                                            "consumerExternalReference",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "invoicingDealDetailsModel.consumerExternalReference"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.hasAddressData || _vm.editable
                              ? [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("City")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value: _vm.consumerAddress.city,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.consumerAddress,
                                              "city",
                                              $$v
                                            )
                                          },
                                          expression: "consumerAddress.city"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Street")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value: _vm.consumerAddress.street,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.consumerAddress,
                                              "street",
                                              $$v
                                            )
                                          },
                                          expression: "consumerAddress.street"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("House")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value: _vm.consumerAddress.house,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.consumerAddress,
                                              "house",
                                              $$v
                                            )
                                          },
                                          expression: "consumerAddress.house"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Apartment")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value: _vm.consumerAddress.apartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.consumerAddress,
                                              "apartment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "consumerAddress.apartment"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Zip")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value: _vm.consumerAddress.zip,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.consumerAddress,
                                              "zip",
                                              $$v
                                            )
                                          },
                                          expression: "consumerAddress.zip"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm.invoicingDealDetailsModel.responsiblePerson ||
                            _vm.invoicingDealDetailsModel.externalUserID
                              ? [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("ResponsiblePerson"))
                                          )
                                        ]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value:
                                            _vm.invoicingDealDetailsModel
                                              .responsiblePerson,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.invoicingDealDetailsModel,
                                              "responsiblePerson",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "invoicingDealDetailsModel.responsiblePerson"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("ExternalUserID"))
                                          )
                                        ]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value:
                                            _vm.invoicingDealDetailsModel
                                              .externalUserID,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.invoicingDealDetailsModel,
                                              "externalUserID",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "invoicingDealDetailsModel.externalUserID"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Branch")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value:
                                            _vm.invoicingDealDetailsModel
                                              .branch,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.invoicingDealDetailsModel,
                                              "branch",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "invoicingDealDetailsModel.branch"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "info-block",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "caption ecgray--text text--darken-2"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Department")))]
                                      ),
                                      _c("v-text-field", {
                                        model: {
                                          value:
                                            _vm.invoicingDealDetailsModel
                                              .department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.invoicingDealDetailsModel,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "invoicingDealDetailsModel.department"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-1",
                              attrs: { color: "success", loading: _vm.loading },
                              on: {
                                click: function($event) {
                                  return _vm.save()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CreateInvoice")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }